
<div class="d-flex justify-content-between align-items-center mb-2 m-2">

    <div class="d-flex align-items-center">
        <span class="badge bg-warning-light px-2 py-1">
            <i class="feather-clock me-1"></i>
            Total en attente : {{ totalAppointmentsOnHold }}
        </span>
    </div>

    <div class="form-check form-switch">
        <input
            class="form-check-input"
            type="checkbox"
            id="hideCancelledCheckbox"
            [(ngModel)]="hideCancelled">

        <label class="form-check-label" for="hideCancelledCheckbox">
            Masquer les rendez-vous annulés
        </label>
    </div>

</div>


<div class="show-dropdown-if-needed table-responsive">

    <table class="table table-hover table-compact">

        <!-- TABLE HEADER -->
        <thead>
            <tr>
                <th class="px-1">Date</th>
                <th class="px-1">Nom</th>
                <th class="px-1">Téléphone</th>
                <th class="px-1">Description</th>
                <th class="px-1">Type</th>
                <th class="px-1">Statut</th>

                <th class="px-1" *ngIf="isDuplicateAllowed()">
                    Affectation
                </th>

                <th *ngIf="actions.payementsView" class="px-1 text-right">
                    M. Total
                </th>

                <th *ngIf="actions.payementsView" class="px-1 text-right">
                    M. Payé
                </th>

                <th *ngIf="actions.payementsView" class="px-1 text-right">
                    Balance
                </th>

                <th *ngIf="actions.payementsView" class="px-1">
                    Paiement
                </th>

                <th class="px-1 text-center">
                    Actions
                </th>
            </tr>
        </thead>


        <!-- TABLE BODY -->
        <tbody>

            <ng-container *ngIf="filteredAppointments.length; else empty">

                <tr
                    *ngFor="let appointment of filteredAppointments"
                    [ngStyle]="{
                        'background-color':
                            appointment.status == 0
                                ? '#FEF9E7'
                                : appointment.status == 2
                                    ? '#ffe0db'
                                    : 'transparent'
                    }">

                    <!-- DATE COLUMN -->
                    <td class="px-1">

                        <div class="fs-13">
                            {{ appointment.date | date:'dd/MM/yyyy' }}
                        </div>

                        <span
                            class="apt-time"
                            [ngStyle]="{
                                'color': appointment.startTime !== 0
                                    ? '#48b9b2'
                                    : 'red'
                            }">

                            {{
                                appointment.startTime !== 0
                                    ? (appointment.startTime | time)
                                    : '--:--'
                            }}

                        </span>

                    </td>


                    <!-- NAME COLUMN -->
                    <td class="px-1">

                        <div class="patient-info-compact">

                            <a
                                (click)="onPatientProfileRequest.emit(appointment)"
                                class="avatar avatar-sm-compact"
                                style="cursor: pointer;">

                                <img
                                    class="avatar-img rounded-circle"
                                    [src]="avatarSrc(appointment)"
                                    [alt]="appointment.patientFirstName + ' ' + appointment.patientLastName" />

                            </a>

                            <div class="patient-details">

                                <div>
                                    <span class="patient-name">
                                        {{
                                            appointment.patient.firstName !== ""
                                                ? appointment.patient.getFullName()
                                                : appointment.patientFirstName + ' ' + appointment.patientLastName
                                        }}
                                    </span>
                                </div>

                                <div>
                                    <span class="patient-birthdate">
                                        {{
                                            (appointment.patient.birthDate | date:"dd/MM/yyyy") !== '01/01/1970'
                                                ? (appointment.patient.birthDate | date:"dd/MM/yyyy")
                                                : (appointment.patientBirthDate | date:"dd/MM/yyyy")
                                        }}
                                    </span>
                                </div>

                            </div>

                        </div>

                    </td>


                    <!-- PHONE COLUMN -->
                    <td class="px-1 fs-12">

                        {{
                            appointment.patient.mobilePhone1 !== ""
                                ? appointment.patient.mobilePhone1
                                : appointment.patientMobilePhone || '---'
                        }}

                    </td>


                    <!-- DESCRIPTION COLUMN -->
                    <td class="px-1 fs-13">
                        {{ appointment.motif || '---' }}
                    </td>


                    <!-- TYPE COLUMN -->
                    <td
                        class="px-1"
                        [ngClass]="{
                            'color-rdv-pre': !appointment.location,
                            'color-rdv-distance': appointment.location
                        }">

                        {{ appointment.location ? "À Distance" : "Présentielle" }}

                    </td>


                    <!-- STATUS COLUMN -->
                    <td class="px-1">

                        <div class="d-inline-block">

                            <span
                                *ngIf="appointment.status == 0"
                                class="btn-sm-compact bg-warning-light px-1">

                                <i class="feather-clock me-1"></i>
                                En Attente

                            </span>

                            <span
                                *ngIf="appointment.status == 1"
                                class="btn-sm-compact bg-success-light px-1">

                                <i class="feather-check-circle me-1"></i>
                                Confirmé

                            </span>

                            <span
                                *ngIf="appointment.status == 2"
                                class="btn-sm-compact bg-danger-light px-1">

                                <i class="feather-x-circle me-1"></i>
                                Annulé

                            </span>

                            <span
                                *ngIf="appointment.status == 3"
                                class="btn-sm-compact bg-info-light px-1">

                                <i class="feather-check me-1"></i>
                                Cloturé

                            </span>

                        </div>

                    </td>


                    <!-- AFFECTATION COLUMN -->
                    <td class="px-1" *ngIf="isDuplicateAllowed()">

                        <span
                            class="badge"
                            [ngStyle]="
                                appointment.assistantId
                                    ? {
                                        'background-color': appointment.assistanceColorCode,
                                        'color': '#000000',
                                        'font-weight': 'bold'
                                    }
                                    : {
                                        'background-color': '#f8d7da',
                                        'color': '#721c24'
                                    }
                            ">

                            <i class="feather-user me-1"></i>

                            {{
                                appointment.assistantId
                                    ? (appointment.assistantFirstName + ' ' + appointment.assistantLastName)
                                    : 'Non assigné'
                            }}

                        </span>

                    </td>


                    <!-- MONTANT TOTAL -->
                    <td
                        *ngIf="actions.payementsView && appointment.location == 0 && !isDuplicateAllowed()">

                        {{
                            appointment.isPaid
                                ? appointment.totalAmount
                                : appointment.regularAmount - appointment.paidAmount
                                | dashboradPaiement
                        }}

                    </td>

                    <td
                        *ngIf="actions.payementsView && appointment.location == 0 && isDuplicateAllowed()">

                        {{
                            ((appointment.isPaid) || (appointment.status == 0))
                                ? appointment.totalAmount
                                : !appointment.isPaid
                                    ? 0
                                    : appointment.regularAmount - appointment.paidAmount
                                | dashboradPaiement
                        }}

                    </td>

                    <td
                        *ngIf="actions.payementsView && appointment.location == 1 && !isDuplicateAllowed()">

                        {{
                            appointment.totalAmount > 0
                                ? appointment.totalAmount
                                : appointment.regularAmount - appointment.paidAmount
                                | dashboradPaiement
                        }}

                    </td>

                    <td
                        *ngIf="actions.payementsView && appointment.location == 1 && isDuplicateAllowed()">

                        {{
                            appointment.totalAmount > 0 && appointment.isPaid
                                ? appointment.totalAmount
                                : 0
                                | dashboradPaiement
                        }}

                    </td>


                    <!-- MONTANT PAYÉ -->
                    <td *ngIf="actions.payementsView && !isDuplicateAllowed()">

                        {{ appointment.paidAmount | dashboradPaiement }}

                    </td>

                    <td *ngIf="actions.payementsView && isDuplicateAllowed()">

                        {{
                            appointment.isPaid
                                ? appointment.paidAmount
                                : 0
                                | dashboradPaiement
                        }}

                    </td>


                    <!-- BALANCE -->
                    <td
                        class="text-center"
                        *ngIf="actions.payementsView && appointment.location == 0 && !isDuplicateAllowed()"
                        [ngClass]="{
                            'text-danger': getRemainingAmount(appointment) > 0,
                            'text-success': getRemainingAmount(appointment) <= 0
                        }">

                        {{
                            getRemainingAmount(appointment) > 0
                                ? '-' + (getRemainingAmount(appointment) | dashboradPaiement)
                                : getRemainingAmount(appointment) < 0
                                    ? '+' + (-getRemainingAmount(appointment) | dashboradPaiement)
                                    : (0 | dashboradPaiement)
                        }}

                    </td>

                    <td
                        class="text-center"
                        *ngIf="actions.payementsView && appointment.location == 1">

                        ---

                    </td>

                    <td
                        class="text-center"
                        *ngIf="actions.payementsView && appointment.location == 0 && isDuplicateAllowed()"
                        [ngClass]="{
                            'text-danger': getRemainingAmount(appointment) > 0,
                            'text-success': getRemainingAmount(appointment) <= 0
                        }">

                        {{
                            appointment.isPaid
                                ? (
                                    getRemainingAmount(appointment) > 0
                                        ? '-' + (getRemainingAmount(appointment) | dashboradPaiement)
                                        : getRemainingAmount(appointment) < 0
                                            ? '+' + (-getRemainingAmount(appointment) | dashboradPaiement)
                                            : (0 | dashboradPaiement)
                                )
                                : (0 | dashboradPaiement)
                        }}

                    </td>


                    <!-- PAIEMENT -->
                    <td *ngIf="actions.payementsView" class="px-1">

                        <span
                            class="payment-status"
                            [ngClass]="{
                                'paid': appointment.isPaid,
                                'not-paid': !appointment.isPaid
                            }">

                            {{ appointment.isPaid ? 'Payé' : 'Non payé' }}

                        </span>

                    </td>


                    <!-- ACTIONS COLUMN -->
                    <td class="px-1">

                        <div class="table-action">


                            <!-- EDIT BUTTON -->
                            <button
                                *ngIf="(!(appointment.hasConsultation || appointment.hasPrescription)) && actions.edit"
                                title="Mise à Jour"
                                class="btn-sm-compact bg-warning-light"
                                (click)="onEditRequest.emit(appointment)">

                                <i class="feather-edit"></i>

                            </button>


                            <!-- BILLING BUTTON -->
                            <button
                                *ngIf="appointment.status == 1 && actions.payementsView"
                                (click)="onBillingRequest.emit(appointment)"
                                title="Paiement"
                                class="btn-sm-compact bg-primary-light">

                                <i class="feather-credit-card"></i>

                            </button>


                            <!-- EXPLORATION BUTTON -->
                            <button
                                class="btn-sm-compact bg-info-light"
                                title="Exploration"
                                *ngIf="
                                    actions.exploration
                                    && !appointment.hasConsultation
                                    && doctorConnect.speciality.label == 'Ophtalmologue'
                                    && doctorConnect.cliniqueId
                                "
                                (click)="onAssignExplorationRequest.emit(appointment)">

                                <i class="feather feather-eye"></i>

                            </button>


                            <!-- REJECT BUTTON -->
                            <button
                                *ngIf="
                                    (appointment.status == 0 || appointment.status == 1)
                                    && !(appointment.hasConsultation || appointment.hasPrescription)
                                    && actions.reject
                                "
                                title="Annuler"
                                class="btn-sm-compact bg-danger-light"
                                (click)="onReject.emit(appointment)">

                                <i class="feather-x"></i>

                            </button>


                            <!-- ACCEPT BUTTON -->
                            <button
                                *ngIf="appointment.status == 0 && actions.accept && appointment.patientId !== ''"
                                title="Confirmé"
                                (click)="onAccept.emit(appointment)"
                                class="btn-sm-compact bg-success-light">

                                <i class="feather-check-circle">Confirmer</i>

                            </button>


                            <!-- ASSIGN BUTTON -->
                            <button
                                *ngIf="appointment.status == 0 && actions.affect && appointment.patientId == ''"
                                title="Assigner"
                                (click)="onAffect.emit(appointment)"
                                class="btn-sm-compact bg-primary-light">

                                <i class="feather-user">Assigner</i>

                            </button>


                            <!-- TELECONSULTATION BUTTON -->
                            <button
                                *ngIf="canOpenTeleconsultation(appointment)"
                                [title]="
                                    appointment.isPaid
                                        ? 'Commencer la teleconsultation'
                                        : 'En attente de paiement client'
                                "
                                [disabled]="!appointment.isPaid"
                                (click)="onViewTeleConsultationRequest.emit(appointment)"
                                class="btn-sm-compact bg-success-light">

                                <i class="feather-play-circle"></i>

                            </button>


                            <!-- PATIENT POSITION -->
                            <div
                                class="presence-control"
                                *ngIf="actions.patientPosition"
                                [attr.data-status]="getPositionIndex(appointment.patientAppointmentStatus)"
                                (click)="stopPresenceMenuPropagation($event)">

                                <!-- CURRENT POSITION -->
                                <button
                                    type="button"
                                    class="presence-main"
                                    (click)="nextPresence(appointment)"
                                    [title]="getPositionLabel(appointment.patientAppointmentStatus)">

                                    <span class="presence-icon">
                                        {{ getPositionIcon(appointment.patientAppointmentStatus) }}
                                    </span>

                                    <span class="presence-label">
                                        {{ getPositionLabel(appointment.patientAppointmentStatus) }}
                                    </span>

                                </button>


                                <!-- OPEN MENU BUTTON -->
                                <button
                                    type="button"
                                    class="presence-arrow"
                                    (click)="togglePresenceMenu(appointment.id, $event)"
                                    [attr.aria-expanded]="openPresenceMenuId === appointment.id"
                                    title="Changer la position">

                                    <i class="feather-chevron-down"></i>

                                </button>


                                <!-- POSITION MENU -->
                                <div
                                    class="presence-menu"
                                    *ngIf="openPresenceMenuId === appointment.id">

                                    <button
                                        type="button"
                                        *ngFor="let position of patientPositions"
                                        [class.active]="appointment.patientAppointmentStatus === position.value"
                                        [disabled]="appointment.patientAppointmentStatus === position.value"
                                        (click)="changePatientPosition(appointment, position.value)">

                                        <span class="presence-menu-icon">
                                            {{ position.icon }}
                                        </span>

                                        <span>
                                            {{ position.label }}
                                        </span>

                                        <i
                                            *ngIf="appointment.patientAppointmentStatus === position.value"
                                            class="feather-check presence-current">
                                        </i>

                                    </button>

                                </div>

                            </div>


                            <!-- CONSULTATION / PRESCRIPTION DROPDOWN -->
                            <div
                                class="dropdown d-inline-block"
                                *ngIf="
                                    (actions.consultations || actions.prescription || actions.attachmentsView)
                                    && appointment.status === 1
                                    && doctorConnect.packPro
                                ">

                                <button
                                    class="btn-sm-compact bg-success-light dropdown-toggle-compact"
                                    type="button"
                                    [id]="'dropdown-' + appointment.id"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    title="Ajout">

                                    <i class="feather feather-menu"></i>

                                </button>


                                <ul
                                    class="dropdown-menu dropdown-menu-end custom-dropdown-menu"
                                    [attr.aria-labelledby]="'dropdown-' + appointment.id">


                                    <!-- CONSULTATION OPTION -->
                                    <li *ngIf="actions.consultations">

                                        <a
                                            class="dropdown-item"
                                            (click)="appointment.hasConsultation
                                                ? onViewConsultationRequest.emit(appointment)
                                                : onAssignConsultationRequest.emit(appointment)">

                                            <i class="feather feather-book-open me-2"></i>

                                            {{
                                                appointment.hasConsultation
                                                    ? 'Liste consultations'
                                                    : 'Ajout consultation'
                                            }}

                                        </a>

                                    </li>


                                    <!-- PRESCRIPTION OPTION -->
                                    <li *ngIf="actions.prescription">

                                        <a
                                            class="dropdown-item"
                                            (click)="appointment.hasPrescription
                                                ? onViewPrescriptionRequest.emit(appointment)
                                                : onAssignPrescriptionRequest.emit(appointment)">

                                            <i
                                                class="me-2"
                                                [ngClass]="
                                                    appointment.hasPrescription
                                                        ? 'feather-eye'
                                                        : 'feather-clipboard'
                                                ">
                                            </i>

                                            {{
                                                appointment.hasPrescription
                                                    ? 'Liste prescription'
                                                    : 'Ajout prescription'
                                            }}

                                        </a>

                                    </li>


                                    <!-- ATTACHMENTS OPTION -->
                                    <li *ngIf="actions.attachmentsView">

                                        <a
                                            class="dropdown-item"
                                            (click)="onViewAttachmentsRequest.emit(appointment)">

                                            <i class="feather-file-plus me-2"></i>

                                            Ajout document

                                        </a>

                                    </li>


                                    <!-- ATTESTATION OPTION -->
                                    <li *ngIf="actions.attestation">

                                        <a
                                            class="dropdown-item"
                                            (click)="onViewAttestationsRequest.emit(appointment)">

                                            <i class="feather-plus-circle me-2"></i>

                                            Ajout Attestation

                                        </a>

                                    </li>

                                </ul>

                            </div>

                        </div>

                    </td>

                </tr>

            </ng-container>


            <!-- EMPTY STATE -->
            <ng-template #empty>

                <tr>

                    <td
                        [attr.colspan]="
                            6
                            + (isDuplicateAllowed() ? 1 : 0)
                            + (actions.payementsView ? 5 : 0)
                            + 1
                        "
                        class="empty-state">

                        <i class="feather-calendar me-2"></i>

                        {{ emptyMessage || 'Pas de rendez-vous !' }}

                    </td>

                </tr>

            </ng-template>

        </tbody>

    </table>

</div>


<!-- PAGINATION -->
<app-pagination
    [currentPage]="currentPage"
    [pageRequest]="pageRequest"
    (content)="doctorAppointments = $event">
</app-pagination>
